import { Button } from "../../../../../components";
import { notification } from "../../../../../services";
import { filtrosContextoLoteValidator } from "../../middlewares/filtros-contexto-lote.validator";

export function MensagemLoteActions({
  activeStep,
  setActiveStep,
  handleSubmit,
  mensagem,
  inputErros,
  steps,
  filtros,
}) {
  const handleAvancarStep = async () => {
    if (activeStep === 0) {
      if (activeStep === 0) {
        try {
          await filtrosContextoLoteValidator.validate(
            {
              contexto: mensagem?.contexto,
              dataVencimentoStart: filtros?.dataVencimentoStart,
              dataVencimentoEnd: filtros?.dataVencimentoEnd,
            },
            { abortEarly: false }
          );
        } catch (err) {
          inputErros.limpar();
          inputErros.set(err);
          notification.alertaGenericos(err.inner[0].message);
          return;
        }
      }
    }
    setActiveStep((prev) => prev + 1);
  };

  const handleVoltarStep = () => {
    setActiveStep((prev) => prev - 1);
  };

  return (
    <div className="d-flex justify-content-between gap-2 px-3">
      {activeStep >= 1 && activeStep <= steps.length - 1 && (
        <Button onClick={handleVoltarStep} color="primary" variant="contained">
          <i
            className="ph-fill ph-caret-left"
            style={{ color: "#fff", fontSize: 18 }}
          ></i>
          Anterior
        </Button>
      )}
      {activeStep < steps.length - 1 && (
        <Button onClick={handleAvancarStep} color="primary" variant="contained">
          Próximo
          <i
            className="ph-fill ph-caret-right"
            style={{ color: "#fff", fontSize: 18 }}
          ></i>
        </Button>
      )}
      {activeStep === steps.length - 1 && (
        <Button onClick={handleSubmit} color="success" variant="contained">
          Salvar
        </Button>
      )}
    </div>
  );
}
